import React from 'react';
import { App, IMember, IObject} from './App';
import strings from './strings.json';
import Reservations from './Reservations';
import { Alert, notification } from 'antd';

import {
    Route,
    Link,
    HashRouter,
    Routes
} from "react-router-dom";

export type locale = "bg" | "en";

export function t(
    locale: locale, 
    key: "loading" | "stoppedLoading" | "fetchingObjectWorktimes" | "tableConflictReserved" | "startTimeGreaterThanEnd"
        | "confirm" | "from" | "to" | "chairs" | "table" | "chooseTable" | "hall" | "date" | "reservationSaved"
        | "returnToMainSite" | "makeAnotherReservation" | "tableReservedForDay" | "error" | "currentReservations"
        | "newReservation" | "home" | "object" | "reservation" | "nameOfGuest" | "hallCapacity" | "chair" | "upstraight"
        | "errorParsingJson" | "tableupperlimitmessage" | "reservedseatsdecreasefortable" | "standingupperlimitmessage"
        | "reservedseatsdecreaseforstanding" | "choosetablebeforeenteringguests" | "mustchoosetable" | "labelremoveguest" 
        | "choosedate" | "addguest" | "textnoreservations" | "onconflict" | "canmakereservationswithmembership" | "upgrademembership" 
        | "or" | "addchild" | "removechild" | "thekid" | "addmember" | "removemember" | "fullcapacity" | "swapchildtoparent" | "swapparenttochild" | "for"
        | "maximumReservationDuration" | "exceededMaximumReservationDuration" | "freeVisitsExhausted" | "guests" | "updateReservation" | "reservationUpdated"
        | "pleaseEnterCommentPlaceholder" | "wholehallreservation" | "modewholehallreservation" | "modesinglereservation" | "currentwholehallreservations"
        | "wholehallplaces" | "reservationcomment" | "wholeHallReservationCancelError"
        | "payment_due" | "payment_table_header_description" | "payment_table_header_value"
        | "payment_table_body_employee_key" | "payment_table_body_employee_true" | "payment_table_body_employee_false"
        | "payment_table_body_free_for_employees_key" | "payment_table_body_free_for_employees_true" | "payment_table_body_free_for_employees_false"
        | "payment_table_body_product_name_key"
        | "payment_table_body_product_quantity_key" | "payment_table_body_quantity_unit"
        | "payment_table_body_price_key" | "payment_table_body_price_unit"
        | "payment_table_body_discount_key"
        | "payment_table_body_effective_discount_key"
        | "payment_table_body_total_due_key"
        | "payment_table_body_member_discount_key"
        | "order_header"
        ) {
    return strings[locale][key];
}

export type ISingleReservation = {
    id: number,
    customerUsername: string,
    objectName: string,
    hallName: string,
    tableName: string,
    startDate: number,
    endDate: number,
    guests: string[],
    objectId: number,
    hallId: number,
    reservedPlaces: number,
    status: number,
    tableId: number;
    comment: string;
};

export type IWholeHallReservation = {
    id: number;
    status: number;
    reservations: ISingleReservation[];
    can_change_reservation_duration: boolean;
    comment?: string;
};


export type IMemberDataObject = {
    member: IMember,
    memberships: [{id: number, name: string}],
}

type MainAppProperties = {
};

type MainAppState = {
    objects: IObject[];
    fetchCompleted: boolean,
    errorString: string,
    objectsWorkTimesFetched: number
    currentLocale: locale,
    membersdata: IMemberDataObject | undefined,    
    reservations: ISingleReservation[],
    wholeHallReservations: IWholeHallReservation[],
};

class MainApp extends React.Component<MainAppProperties, MainAppState> {
    state: MainAppState = {
        objects: [],
        fetchCompleted: false,
        errorString: "", 
        objectsWorkTimesFetched: 0,
        currentLocale: 'bg',
        membersdata: undefined,
        reservations: [],
        wholeHallReservations: [],
    };

    constructor(properties: MainAppProperties) {
        super(properties);

        this.fetchHalls = this.fetchHalls.bind(this);
        this.fetchObjectsWorkTimes = this.fetchObjectsWorkTimes.bind(this);
        this.fetchMemberData = this.fetchMemberData.bind(this);

        this.createRequiredMembershipMessage = this.createRequiredMembershipMessage.bind(this);
        this.hasRequiredMembership = this.hasRequiredMembership.bind(this);
        this.hasFreeVisits = this.hasFreeVisits.bind(this);

        this.fetchReservations = this.fetchReservations.bind(this);
        this.fetchWholeHallReservations = this.fetchWholeHallReservations.bind(this);

        let localeInput = document.getElementById("locale");
        if(localeInput) {
            let locale = (localeInput as HTMLInputElement).value
            if(locale === "bg" || locale === "en") {
                this.state.currentLocale = locale;
            }
        }        
    }

    fetchWholeHallReservations() {
        let start = new Date(Date.now());
        start.setHours(0, 0, 0,0);

        let end = new Date(start);
        end.setFullYear(start.getFullYear() + 1, start.getMonth(), start.getDate());

        let s: number = Math.floor(start.getTime() / 1000), e:number = Math.ceil(end.getTime() / 1000);
        fetch(`${process.env.REACT_APP_API_PREFIX}/reservations/api/getuserwholehallreservations?start=${encodeURIComponent(s)}&end=${encodeURIComponent(e)}`, {
            credentials: 'include'
        }).then( (response) => {
            response.json().then( (value) => {
                this.setState( () => {
                    return {
                        wholeHallReservations: value,
                    };
                });
            });
        }).catch( (reason) => {
            notification.error( { message: 'Error getting reservations', description: reason } );
        }); 
    }

    fetchReservations() {
        let start = new Date(Date.now());
        start.setHours(0, 0, 0,0);

        let end = new Date(start);
        end.setFullYear(start.getFullYear() + 1, start.getMonth(), start.getDate());

        let s: number = Math.floor(start.getTime() / 1000), e:number = Math.ceil(end.getTime() / 1000);
        fetch(`${process.env.REACT_APP_API_PREFIX}/reservations/api/getuserreservations?start=${encodeURIComponent(s)}&end=${encodeURIComponent(e)}`, {
            credentials: 'include'
        }).then( (response) => {
            response.json().then( (value) => {
                this.setState( (_, __) => {
                    return {
                        reservations: value,
                    }
                }, () => {
                    this.fetchWholeHallReservations();
                });
            });
        }).catch( (reason) => {
            notification.error( { message: 'Error getting reservations', description: reason } );
        });
    }

    hasFreeVisits(object: IObject): boolean
    {
        if(object.hasFreeVisits === true && object.remainingFreeVisits > 0)
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    hasRequiredMembership(memberdata: IMemberDataObject, object: IObject): boolean
    {
        return object.allowedMemberships.includes(memberdata.member.currentMembershipId);
    }

    createRequiredMembershipMessage(object: IObject, memberDataObject: IMemberDataObject)
    {       
        let requiredMemberships = object.allowedMemberships.map( (membershipId) => {
            return memberDataObject.memberships.find( (membership) => {
                return membership.id === membershipId;
            });            
        });

        let requiredMembershipNames = requiredMemberships.map( membership => {
            return membership?.name;
        }).join(` ${t(this.state.currentLocale, "or")} `);

        let message = `${t(this.state.currentLocale, "canmakereservationswithmembership")} ${requiredMembershipNames}.`;
        
        let description: string | undefined = undefined;
        if(object.hasFreeVisits && !this.hasFreeVisits(object))
        {
            description = `${t(this.state.currentLocale, "freeVisitsExhausted")}`;
        }

        return <Alert 
            type="warning"
            showIcon
            message={message}
            description={description ? description : <React.Fragment></React.Fragment>}
        />

    }

    componentDidMount() {        
        this.fetchMemberData();             
    }    

    fetchMemberData()
    {
        fetch(`${process.env.REACT_APP_API_PREFIX}/reservations/api/memberdata`, { credentials: 'include' })
        .then( response => {
            if(response.status === 401) {
                response.text().then( (apiErrorString) => {
                    this.setState( (_, __) => {
                        return {fetchCompleted: true, errorString: apiErrorString};
                    });
                })
                .catch( reason => {
                    this.setState( (_, __) => {
                        return {fetchCompleted: true, errorString: reason};
                    });
                });                
            } else if (response.status === 200) {
                response.json().then( json => {
                    this.setState( (_, __) => {
                        return { membersdata: json };
                    }, () => {
                        this.fetchHalls();
                        this.fetchReservations();
                    });
                }).catch( reason => {
                    this.setState( (_, __) => {
                        return {fetchCompleted: true, errorString: t(this.state.currentLocale, "errorParsingJson")};
                    })
                });              
            }
        });
    }

    fetchObjectsWorkTimes() {
        this.state.objects.map( async (object: IObject, index:number, array: IObject[]) => {
            let response = await fetch(`${process.env.REACT_APP_API_PREFIX}/reservations/api/getworktime?objectId=${encodeURIComponent(object.id)}`, {
                credentials: 'include'
            });
            let json = await response.json();
            array[index].worktime = json;
            this.setState( (previousState: MainAppState, previousProperties: MainAppProperties) => {
                return {
                    objectsWorkTimesFetched: previousState.objectsWorkTimesFetched + 1,
                };
            }, () => {
                if(this.state.objects.length === this.state.objectsWorkTimesFetched) {
                    this.setState( (prevState: MainAppState, prevProps: MainAppProperties) => {
                        return {
                            fetchCompleted: true,
                        }
                    });
                }
            });
        });
    }

    fetchHalls() {
        fetch(`${process.env.REACT_APP_API_PREFIX}/reservations/api/getallobjects`, {
            credentials: 'include',             
        }).then( (response) => {
                if(response.status === 401) {
                    response.text().then( (value: string) => {
                        this.setState( (previousState: MainAppState, previousProperties: MainAppProperties) => {                        
                            return {
                                fetchCompleted: true,
                                errorString: value,
                            }
                        });
                    });
                } else {
                    response.json().then( (value) => {                                                                 
                        this.setState( (previousState: MainAppState, previousProperties: MainAppProperties) => {                                                                                    
                            return {
                                objects: value,
                                fetchCompleted: false,
                                errorString: "",
                            };
                        }, () => {
                            this.fetchObjectsWorkTimes();
                        });
                    }).catch( (reason) => {
                        this.setState( (previousState: MainAppState, previousProperties: MainAppProperties) => {
                            return {
                                fetchCompleted: true,
                                errorString: t(this.state.currentLocale, "errorParsingJson"),
                            }
                        }); 
                    });
                }
        }).catch( (reason) => {
            this.setState( (previousState: MainAppState, previousProperties: MainAppProperties) => {
                return {
                    fetchCompleted: true,
                    errorString: reason,
                }
            }); 
        });        
    }

    render() {
        if(this.state.fetchCompleted && this.state.errorString.length > 0 && this.state.errorString.toLowerCase() === "Not a logged in user!".toLowerCase()) {
            window.location.href= `/login?login_redirect=%2F${this.state.currentLocale}%2Freservations`;
        }

        return (   
            <HashRouter>
                
            <div>
                <div>
                <div className={'col s1 m3 l4'}>&nbsp;</div>
                <div className={'box-transparent-background col s10 m6 l4'} style={{marginTop: '3rem'}}>
                    <div style={{ display: 'block', paddingTop: '1rem'}}></div>
                {this.state.fetchCompleted ? <div>
                {this.state.errorString.length > 0 ? 
                                        <p>{t(this.state.currentLocale, "stoppedLoading")}-<span style={{ color: 'red', fontWeight: 'bold'}}>{this.state.errorString}</span></p>
                : <div>{this.state.objects.length === this.state.objectsWorkTimesFetched ? 
                    <React.Fragment>  
                        <Routes>                          
                                {this.state.objects.map( (object: IObject) => {
                                    if(this.state.membersdata)
                                    {                                        
                                        if(this.hasRequiredMembership(this.state.membersdata, object) || this.hasFreeVisits(object)) {
                                            

                                            // TODO: replace with something saner
                                            const cybarObject = this.state.objects.find( (obj, idx) => {
                                                if(obj.id === 1 && obj.name.localeCompare("CYBAR") === 0) {
                                                    return true;
                                                }
                                            });
                                            // TODO: end note
                                            return (
                                                <Route 
                                                    path={"/createreservation/" + object.id.toString()} 
                                                    element={<App cybarObject={cybarObject} locale={this.state.currentLocale} object={object} member={this.state.membersdata?.member} onMakeOrUpdateReservation={() => this.fetchReservations()} /> } 
                                                />
                                                );                                    
                                        } else {
                                            return <></>;
                                        }                                                                   
                                    }  
                                    else {
                                        return <></>;
                                    }     
                                })}         

                                
                                {this.state.reservations.map( (reservation) => {
                                    if(this.state.membersdata) {
                                        
                                        let object: IObject | undefined = this.state.objects.find( (value) => {
                                            return value.id === reservation.objectId;
                                        });

                                        if(object)
                                        {
                                            return (<Route 
                                                path={"/editreservation/"  + reservation.id.toString()} 
                                                element={<App locale={this.state.currentLocale} object={object} member={this.state.membersdata.member} reservation={reservation} onMakeOrUpdateReservation={() => this.fetchReservations()} /> }
                                                />                                                
                                            );
                                        }
                                        else {
                                            return <></>;
                                        }                                       
                                    } else {
                                        return <></>;
                                    }
                                })}

                                {this.state.wholeHallReservations.map( (reservation) => {
                                    if(this.state.membersdata) {
                                        
                                        let object: IObject | undefined = this.state.objects.find( (value) => {
                                            return value.id === reservation.reservations[0].objectId;
                                        });

                                        if(object)
                                        {
                                            return (<Route 
                                                path={"/editwholereservation/"  + reservation.id.toString()} 
                                                element={<App locale={this.state.currentLocale} object={object} member={this.state.membersdata.member} wholeHallReservation={reservation} onMakeOrUpdateReservation={() => this.fetchReservations()} /> }
                                                />                                                
                                            );
                                        }
                                        else {
                                            return <></>;
                                        }                                       
                                    } else {
                                        return <></>;
                                    }
                                })}

                                <Route 
                                    path="/"
                                    element={
                                        <>
                                    {this.state.objects.length > 0 ? <h4 className={'no-padding-left play-bold'} style={{textAlign: 'center'}}>{t(this.state.currentLocale, "newReservation")}</h4> : '' }
                                    {this.state.objects.map( (object: IObject, index: number) => {
                                        return (
                                        <React.Fragment>
                                        <div className={'col s12 valign-wrapper'} style={{textAlign: 'center', marginTop: '1rem', marginBottom: '1rem'}}>
                                            <div className={'s3'} style={{textAlign: 'left'}}><img src={`${process.env.REACT_APP_API_PREFIX}/themes/mdosc-materialize-redesign/assets/reservations/object-${object.id}-logo.png`} style={{height: '3rem', marginRight: '1rem'}} alt="" /><br/></div>                                            
                                            <div className={'s9'} style={{textAlign: 'left'}}>
                                                {this.state.membersdata ? 
                                                this.hasRequiredMembership(this.state.membersdata, object) || this.hasFreeVisits(object)
                                                ?  <Link to={"/createreservation/" + object.id.toString()}>{object.name}</Link>
                                                : 
                                                    <React.Fragment>
                                                        <span style={{color: 'gray'}}>{object.name}</span><br />
                                                        {this.createRequiredMembershipMessage(object, this.state.membersdata)}
                                                    </React.Fragment>
                                                : t(this.state.currentLocale, "errorParsingJson") }
                                            </div>
                                        </div>                                        
                                        </React.Fragment>
                                        )
                                    })}
                                    {this.state.membersdata ? <Reservations locale={this.state.currentLocale} objects={this.state.objects} membersdata={this.state.membersdata} reservations={this.state.reservations} wholeHallReservations={this.state.wholeHallReservations} onDeleteReservation={() => this.fetchReservations()}/> : <React.Fragment></React.Fragment>}                                    
                                    </> 
                                    }
                                />  
                                </Routes> 
                    </React.Fragment>
                            :
                            <span>{t(this.state.currentLocale, "fetchingObjectWorktimes")}...</span>}</div> }</div>
                : <div><span>{t(this.state.currentLocale, "loading")}</span></div>}
                <div style={{ display: 'block', paddingTop: '1rem'}}></div>
                </div>
                <div className={'col s1 m3 l4'}>&nbsp;</div>
                </div>
            </div>      
                 
            </HashRouter>
        );
    }
}

export default MainApp;